import { useParams, useSearchParams } from "react-router-dom";
import { useStationOrders } from "../hooks/useOrders";
import OrderCard from "../components/OrderCard";

export default function StationView() {
  const { stationId } = useParams();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId") || localStorage.getItem("kitchen_clientId");

  const { data: orders } = useStationOrders(stationId ?? null, clientId);

  return (
    <div className="min-h-screen bg-kds-bg p-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-order-num text-kds-text">Stazione</h1>
        <span className="text-kds-muted">
          {orders?.length ?? 0} ordini
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {(orders ?? []).map((order: any) => (
          <OrderCard key={order.id} order={order} />
        ))}
      </div>

      {(!orders || orders.length === 0) && (
        <div className="text-center text-kds-muted py-20">
          <p className="text-xl">Nessun ordine attivo</p>
        </div>
      )}
    </div>
  );
}
